import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type Context = {
  scrollDisabled: boolean;
  registerOverlay: (id: string) => void;
  unregisterOverlay: (id: string) => void;
};

const CalendarScrollContext = createContext<Context>({
  scrollDisabled: false,
  registerOverlay: () => null,
  unregisterOverlay: () => null,
});

export const CalendarScrollContextProvider = ({ children }) => {
  const [registered, setRegistered] = useState<string[]>([]);
  const registerOverlay = useCallback(
    (id: string) => setRegistered((s) => (s.includes(id) ? s : [...s, id])),
    [setRegistered],
  );

  const unregisterOverlay = useCallback(
    (id: string) => setRegistered((s) => s.filter((el) => el !== id)),
    [setRegistered],
  );

  const scrollDisabled = useMemo(() => registered.length > 0, [registered]);

  return (
    <CalendarScrollContext.Provider
      value={{
        scrollDisabled,
        registerOverlay,
        unregisterOverlay,
      }}
    >
      {children}
    </CalendarScrollContext.Provider>
  );
};

export const useCalendarScroll = () => useContext(CalendarScrollContext);
